import React from "react";
import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa";
import { isRtlLanguage } from "../../utils/i18n";

function DropdownMenu({ onLanguageChange }) {
  const { i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);

  const switchLanguage = (language) => {
    onLanguageChange?.();
    i18n.changeLanguage(language);
  };

  return (
    <div className="dropdown relative z-10 flex items-center gap-3 sm:gap-5">
      <FaGlobe className="fa-regular text-xl text-white sm:text-2xl" aria-hidden="true" />
      <ul className="dropdown-menu flex items-center gap-2">
        <li>
          <button
            type="button"
            className={isRtl ? "hidden" : "enFont text-sm font-bold text-white"}
            onClick={() => switchLanguage("ar")}
          >
            Ar
          </button>
        </li>
        <li>
          <button
            type="button"
            className={isRtl ? "arFont text-sm font-bold text-white" : "hidden"}
            onClick={() => switchLanguage("en")}
          >
            En
          </button>
        </li>
      </ul>
    </div>
  );
}

export default DropdownMenu;
